import { FormControlOverrides } from 'baseui/form-control';

export const FORM_CONTROL: FormControlOverrides = {
  Label: {
    style: {
      marginTop: '16px',
    },
  },
  ControlContainer: {
    style: {
      marginBottom: '32px',
    },
  },
};
